import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { api } from './services/api'
import { quickPartsApi } from './services/quickPartsApi'
import appReducer from './slices/appSlice'
import contactsReducer from './slices/contactsSlice'
import customerReducer from './slices/customerSlice'
import cuttingTechnologiesReducer from './slices/cuttingTechnologiesSlice'
import guestUserSlice from './slices/guestUserSlice'
import materialsReducer from './slices/materialsSlice'
import miscItemsReducer from './slices/miscItemsSlice'
import orderItemsReducer from './slices/orderItemsSlice'
import organisationReducer from './slices/organisationSlice'
import ratesReducer from './slices/ratesSlice'
import rateTablesReducer from './slices/rateTablesSlice'
import sheetsReducer from './slices/sheetsSlice'

const persistConfig = {
    key: 'qt',
    version: 4,
    storage,
    whitelist: ['displayOrderPricing', 'showDrawingDoctorLegend'],
}

const persistedAppReducer = persistReducer(persistConfig, appReducer)

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        [quickPartsApi.reducerPath]: quickPartsApi.reducer,
        appSlice: persistedAppReducer,
        contactsSlice: contactsReducer,
        customerSlice: customerReducer,
        guestUserSlice: guestUserSlice,
        cuttingTechnologiesSlice: cuttingTechnologiesReducer,
        materialsSlice: materialsReducer,
        miscItemsSlice: miscItemsReducer,
        organisationSlice: organisationReducer,
        orderItemsSlice: orderItemsReducer,
        ratesSlice: ratesReducer,
        rateTablesSlice: rateTablesReducer,
        sheetsSlice: sheetsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
            .concat(api.middleware)
            .concat(quickPartsApi.middleware),
    devTools: process.env.NODE_ENV === 'development',
})

setupListeners(store.dispatch)

export const persistor = persistStore(store)
